import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue"
export default {
  name: 'ApplicantTransition',
  components:{
    NavigationBackButton
  }
  // Component logic would go here
}